import React from "react";

const summaryStyle = { fontSize: "0.8125rem" };
const changesPillStyle = {
  backgroundColor: "rgba(40, 55, 84, 0.08)",
  color: "var(--bs-primary, #283754)",
};

export default function PreviewFormModalSummary({
  totalFields,
  modifiedCount,
}) {
  const hasChanges = modifiedCount > 0;

  return (
    <div
      className="d-flex align-items-center gap-3 px-4 py-2 border-bottom bg-white"
      style={summaryStyle}
      role="status"
      aria-live="polite"
    >
      <span className="d-flex align-items-center gap-1 text-muted">
        <i className="bi bi-list-ul" aria-hidden />
        <span>
          <strong className="text-dark">{totalFields}</strong>{" "}
          {totalFields === 1 ? "field" : "fields"} to review
        </span>
      </span>
      {hasChanges && (
        <span
          className="d-flex align-items-center gap-1 px-2 py-0 rounded"
          style={changesPillStyle}
        >
          <i className="bi bi-pencil-square" aria-hidden />
          <span>
            <strong>{modifiedCount}</strong>{" "}
            {modifiedCount === 1 ? "change" : "changes"}
          </span>
        </span>
      )}
    </div>
  );
}
